var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ExcelImport',{on:{"onDataImported":_vm.onDataImported}}),_c('PreviewStudents',{ref:"preview-student-dialog",on:{"onSave":_vm.onSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }